import React from 'react'

function Rep_BedOccupancyTrends() {
  return (
    <div>Bed Occupancy Trends</div>
  )
}

export default Rep_BedOccupancyTrends